export const getTooltipDataKey = (str: string) =>
  str.replace(/\W+(.)/g, (_match: string, chr: string) => chr.toUpperCase());
